import { apiGet } from './client';
import type { Merchant, OperationResult, PagedItemsResult } from './types';

// Wraps GET /api/Merchant/List which returns OperationResult<PagedItemsResult<Merchant>>.
// We unwrap so callers get a plain { items, totalCount, ... } shape.

export interface MerchantListParams {
  search?: string;
  pageNo?: number;
  pageSize?: number;
}

export async function getMerchantList(
  params: MerchantListParams = {}
): Promise<PagedItemsResult<Merchant>> {
  const { search = '', pageNo = 1, pageSize = 50 } = params;
  const result = await apiGet<OperationResult<PagedItemsResult<Merchant>>>('/api/Merchant/List', {
    search,
    pageNo,
    pageSize,
  });
  if (!result.isSuccess || !result.data) {
    throw new Error(result.message || 'Failed to load merchants');
  }
  return result.data;
}
